let uniqCount = 0;

export function uniqueId(): number {
  uniqCount++;
  return uniqCount;
}
